import React from 'react';
import { NoSsr } from '@mui/material';
import useBreakpointStatus from '../../hooks/useBreakpointStatus';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

interface HeaderProps {
  children?: React.ReactNode;
  hideRightRailButton?: boolean;
}

const BREAKPOINT_FOR_MOBILE_HEADER = 'xs';

/**
 * @description A layout component that either renders the desktop or mobile header based on the breakpoint status.
 */
export default function Header({
  children,
  hideRightRailButton = false,
}: HeaderProps) {
  const bpStatus = useBreakpointStatus({
    breakpointToCover: BREAKPOINT_FOR_MOBILE_HEADER,
  });
  const Wrapper =
    bpStatus && (bpStatus.isAtBreakpoint || bpStatus.isBelowBreakpoint)
      ? MobileHeader
      : DesktopHeader;

  return (
    <NoSsr>
      <Wrapper hideRightRailButton={hideRightRailButton}>{children}</Wrapper>
    </NoSsr>
  );
}
